(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dmx-grade"] && !Shopify.designMode) return;
  try {
    if (!window.dmxGradeTips) {
    window.dmxGradeTips = true;

    const floatId = 'dmx-grade-tip';
    let current = null;

    const floatTip = () => {
      let tip = document.getElementById(floatId);
      if (tip) return tip;
      tip = document.createElement('div');
      tip.id = floatId;
      tip.className = 'dmx-grade__float';
      tip.setAttribute('role', 'tooltip');
      tip.hidden = true;
      document.body.appendChild(tip);
      return tip;
    };

    const hide = () => {
      const tip = document.getElementById(floatId);
      if (tip) tip.hidden = true;
      current?.querySelector('.dmx-grade__badge')?.removeAttribute('aria-describedby');
      current = null;
    };

    const show = (item) => {
      const def = item.querySelector('.dmx-grade__def');
      const badge = item.querySelector('.dmx-grade__badge');
      if (!def || !badge || !def.textContent.trim()) return;
      const tip = floatTip();
      tip.innerHTML = def.innerHTML;
      tip.hidden = false;
      const rect = badge.getBoundingClientRect();
      let left = rect.left;
      let top = rect.top - tip.offsetHeight - 8;
      if (top < 8) top = rect.bottom + 8;
      if (left + tip.offsetWidth > window.innerWidth - 8) left = window.innerWidth - tip.offsetWidth - 8;
      if (left < 8) left = 8;
      tip.style.left = `${left}px`;
      tip.style.top = `${top}px`;
      badge.setAttribute('aria-describedby', floatId);
      current = item;
    };

    document.addEventListener('pointerover', (event) => {
      const item = event.target.closest?.('.dmx-grade__item');
      if (!item || item === current) return;
      hide();
      show(item);
    });

    document.addEventListener('pointerout', (event) => {
      if (!current) return;
      const item = event.target.closest?.('.dmx-grade__item');
      if (item !== current || current.contains(event.relatedTarget)) return;
      hide();
    });

    document.addEventListener('focusin', (event) => {
      const item = event.target.closest?.('.dmx-grade__item');
      if (!item || item === current) return;
      hide();
      show(item);
    });

    document.addEventListener('focusout', (event) => {
      if (!current || current.contains(event.relatedTarget)) return;
      hide();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hide();
    });

    window.addEventListener(
      'scroll',
      () => {
        if (current) hide();
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
